export default "__VITE_ASSET__891af2eb__"